import React from 'react';
import { COMMUNICATIONS_ENABLED } from '../../constants/featureFlags';
import CommunicationsView from '../CommunicationsView';

/** Renders the Communications screen only while the COMMUNICATIONS_ENABLED flag is on. */
const CommunicationsRoute: React.FC = () => (COMMUNICATIONS_ENABLED ? <CommunicationsView /> : null);

export default CommunicationsRoute;
